<!-- Created by henian.xu on 2018/7/20. -->

<template>
    <page>
        <!-- 表单区 -->
        <template slot="secondHeader">
            <el-form
                ref="queryForm"
                class="second-header npa-b"
                size="small"
                :inline="true"
                :model="queryFormModel"
            >
                <el-form-item
                    prop="objectCode"
                    label="对象代码"
                >
                    <el-input
                        v-model="queryFormModel.objectCode"
                        placeholder="请输入对象代码"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="onQuery()"
                    >
                        查询
                    </el-button>
                    <el-button
                        type="success"
                        @click="onReset"
                    >
                        重置
                    </el-button>
                </el-form-item>
            </el-form>
        </template>

        <!-- 内容 -->
        <div
            class="body"
            slot="body"
            v-loading="querying"
        >
            <!-- 操作 -->
            <div
                class="ma-b"
            >
                <el-button-group>
                    <el-button
                        type="success"
                        icon="el-icon-plus"
                        size="small"
                        @click="onAdd"
                    >
                        新增
                    </el-button>
                    <el-button
                        type="danger"
                        icon="el-icon-delete"
                        size="small"
                        @click="onDelete"
                        :disabled="!currentTableSelect.length"
                    >
                        删除
                    </el-button>
                </el-button-group>
            </div>

            <!-- 表格 -->
            <el-table
                stripe
                border
                size="small"
                :data="tableData"
                style="width: 100%"
                @selection-change="onTableSelectionChange"
            >
                <el-table-column
                    type="selection"
                    width="36"
                />
                <el-table-column
                    prop="objectCode"
                    label="对象代码"
                    min-width="100"
                />
                <el-table-column
                    label="创建时间"
                    min-width="150"
                >
                    <template slot-scope="scope">
                        {{ scope.row.insertTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="修改时间"
                    min-width="150"
                >
                    <template slot-scope="scope">
                        {{ scope.row.updateTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="90"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="onTableEdit(scope.row)"
                        >
                            编辑
                        </el-button>
                        <el-button
                            type="text"
                            size="small"
                            @click="onTableDelete(scope.row.id)"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="ma-t ta-r">
                <pagination
                    v-model="pagination"
                    @input="onQuery"
                />
            </div>
        </div>

        <!-- 弹框 -->
        <!-- 新增/编辑 -->
        <el-dialog
            :title="addDialog.formModel.id ? '编辑' : '新增'"
            center
            width="1200px"
            :visible.sync="addDialog.isVisible"
            @closed="onAddDialogCancel"
        >
            <el-form
                ref="addForm"
                size="small"
                :model="addDialog.formModel"
                :rules="addDialog.formRules"
            >
                <el-form-item
                    prop="objectCode"
                    label="对象代码"
                    label-width="6em"
                >
                    <el-input
                        v-model="addDialog.formModel.objectCode"
                        auto-complete="off"
                    />
                </el-form-item>
                <el-form-item
                    label="配置"
                    label-width="6em"
                >
                    <div
                        class="ma-b"
                    >
                        <el-button-group>
                            <el-button
                                type="success"
                                icon="el-icon-plus"
                                size="small"
                                @click="onAddItem()"
                            >
                                新增
                            </el-button>
                        </el-button-group>
                    </div>
                    <!-- 表格 -->
                    <el-table
                        stripe
                        border
                        size="small"
                        :data="addDialog.formModel.objectConfig"
                        style="width: 100%"
                        :tree-props="{children: 'children'}"
                        row-key="id"
                        ref="treeTable"
                    >
                        <el-table-column
                            prop="id"
                            label="id"
                            width="180"
                        />
                        <el-table-column
                            prop="fieldSearch"
                            label="字段查询名称"
                            min-width="100"
                        >
                            <template slot-scope="scope">
                                <el-input
                                    v-model="scope.row.fieldSearch"
                                    auto-complete="off"
                                />
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="tableCode"
                            label="表名称"
                            min-width="100"
                        >
                            <template slot-scope="scope">
                                <el-input
                                    v-model="scope.row.tableCode"
                                    auto-complete="off"
                                />
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="fieldCode"
                            label="字段名称"
                            min-width="100"
                        >
                            <template slot-scope="scope">
                                <el-input
                                    v-model="scope.row.fieldCode"
                                    auto-complete="off"
                                />
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="dataId"
                            label="数据ID名称"
                            min-width="100"
                        >
                            <template slot-scope="scope">
                                <el-input
                                    v-model="scope.row.dataId"
                                    auto-complete="off"
                                />
                            </template>
                        </el-table-column>
                        <el-table-column
                            fixed="right"
                            label="操作"
                            width="90"
                        >
                            <template slot-scope="scope">
                                <el-button
                                    type="text"
                                    size="small"
                                    @click="onAddItemLeaf(scope.row)"
                                >
                                    新增
                                </el-button>
                                <el-button
                                    type="text"
                                    size="small"
                                    @click="onDeleteItem(scope.row)"
                                >
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
            </el-form>
            <div
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    type="primary"
                    size="small"
                    @click="onAddDialogConfirm"
                >
                    确 定
                </el-button>
                <el-button
                    size="small"
                    @click="onAddDialogCancel"
                >
                    取 消
                </el-button>
            </div>
        </el-dialog>
    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';
import { queryFormList } from 'vmf/src/mixins';
import { Utils } from 'vmf';

export default {
    name: 'LanguageDataConf',
    mixins: [pagesMixin, queryFormList],
    data() {
        return {
            queryFormModel: {
                objectCode: '', // 对象代码
            },
            // 新增/编辑
            addDialog: {
                // 对话框显示
                isVisible: false,
                // 表单数据
                formModel: {
                    id: '',
                    objectCode: '',
                    objectConfig: [],
                },
                // 表单校验规则
                formRules: {
                    objectCode: {
                        required: true,
                        message: '请输入对象代码',
                        trigger: 'blur',
                    },
                },
                objectConfigMap: {},
            },
            // 表格数据
            tableData: [],
            // 表格当前选中行
            currentTableSelect: [],
        };
    },
    methods: {
        /* -- 方法 -- */
        // 请求列表数据
        getListData(queryData) {
            return this.$api.Rs.LanguageDataConf.data(queryData).then(json => {
                const res = json.data;
                this.tableData = res.data;
                this.pagination = res.pagination;
                return Promise.resolve(json);
            });
        },
        /* -- 事件 -- */
        onAdd() {
            this.addDialog.isVisible = true;
            this.addDialog.objectConfigMap = {};
            this.$nextTick(() => {
                const { addForm } = this.$refs;
                addForm.resetFields();
                const { formModel } = this.addDialog;
                formModel.id = '';
                formModel.objectConfig = [];
            });
        },
        onTableSelectionChange(val) {
            this.currentTableSelect = val;
        },
        onTableEdit(row) {
            const { formModel } = this.addDialog;
            this.addDialog.objectConfigMap = {};
            this.$api.Rs.LanguageDataConf.getDetail({ id: row.id }).then(json => {
                const res = json.data.data;
                this.$utils.formModelMerge(formModel, res);
                if (res.objectConfig) {
                    this.addDialog.formModel.objectConfig = JSON.parse(res.objectConfig);
                } else {
                    this.addDialog.formModel.objectConfig = [];
                }
                this.initMap(this.addDialog.formModel.objectConfig);
            });
            this.addDialog.isVisible = true;
        },
        initMap(list) {
            list.forEach(item => {
                this.addDialog.objectConfigMap[item.id] = item;
                if (!!item.children && item.children.length !== 0) {
                    this.initMap(item.children);
                }
            });
        },
        onTableDelete(ids) {
            this.$confirm('是否确定要删除！', '温馨提示', {
                type: 'warning',
            }).then(() => {
                this.$api.Rs.LanguageDataConf.delete({ ids }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.onQuery(this.pagination);
                });
            });
        },
        onDelete() {
            const ids = this.currentTableSelect.reduce((prev, next) => {
                prev.push(next.id);
                return prev;
            }, []);
            this.onTableDelete(ids.join(','));
        },
        onAddDialogConfirm() {
            const { addForm } = this.$refs;
            addForm.validate().then(() => {
                this.$api.Rs.LanguageDataConf.save({
                    ...this.addDialog.formModel,
                    objectConfig: JSON.stringify(this.addDialog.formModel.objectConfig),
                }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.onQuery(this.pagination);
                    this.addDialog.isVisible = false;
                });
            });
        },
        onAddDialogCancel() {
            const { addForm } = this.$refs;
            addForm.resetFields();
            const { formModel } = this.addDialog;
            formModel.id = '';
            this.addDialog.isVisible = false;
        },
        onAddItem() {
            const item = {
                id: Utils.getUniqueId(),
                children: [],
            };
            this.addDialog.objectConfigMap[item.id] = item;
            this.addDialog.formModel.objectConfig.push(item);
        },
        onDeleteItem(row) {
            if (row.parentId) {
                this.addDialog.objectConfigMap[row.parentId].children.splice(
                    this.addDialog.objectConfigMap[row.parentId].children.indexOf(row),
                    1,
                );
            } else {
                this.addDialog.formModel.objectConfig.splice(this.addDialog.formModel.objectConfig.indexOf(row), 1);
            }
        },
        onAddItemLeaf(row) {
            const item = {
                id: Utils.getUniqueId(),
                children: [],
                parentId: row.id,
            };
            row.children.push(item);
            this.addDialog.objectConfigMap[item.id] = item;
            this.$nextTick(() => {
                this.$refs.treeTable.toggleRowExpansion(row, true);
            });
        },
    },
};
</script>

<style lang="scss">
</style>
